import { CapsuleGeometry, Matrix4, Mesh, Vector3 } from 'three';
import { H3BasicMaterial } from '../../materials/basic/h3-basic-material';

const direction = new Vector3();

export class PoleMesh extends Mesh<CapsuleGeometry, H3BasicMaterial> {
  constructor(startPoint: Vector3, endPoint: Vector3, radius: number) {
    // Start with scale of 1 = 1 world unit
    const startingScale = 1;
    const geometry = new CapsuleGeometry(radius, startingScale);

    // make it rest on the origin
    geometry.applyMatrix4(
      new Matrix4().makeTranslation(0, startingScale / 2, 0),
    );
    geometry.applyMatrix4(new Matrix4().makeRotationX(Math.PI / 2));
    super(geometry);

    this.userData = { meshType: 'PoleMesh' };

    this.fitPoints(startPoint, endPoint);
  }

  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }

  setMaterial(material: H3BasicMaterial) {
    this.material.dispose();
    this.material = material;
  }

  fitPoints(startPoint: Vector3, endPoint: Vector3) {
    direction.subVectors(endPoint, startPoint);

    this.scale.setZ(direction.length());
    this.position.copy(startPoint);
    this.lookAt(endPoint);
  }
}
